module.exports = __webpack_public_path__ + "static/img/merchant-icon-logo.da4c14c5.jpg";